import { lazy } from 'react';

// project imports
import MinimalLayout from 'layout/MinimalLayout';
import UserLoginPage from 'modules/auth/pages/UserLoginPage';
import EmployeeForgotPassword from 'modules/forgot-password/pages/EmployeeForgotPassword';
import EmployeeForgotPasswordRequest from 'modules/forgot-password/pages/EmployeeForgotPasswordRequest';
import Loadable from 'ui-component/Loadable';

// login option 3 routing
const LoginPage = Loadable(lazy(() => import('modules/auth/pages/LoginPage')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '',
    element: <MinimalLayout />,
    children: [
        {
            path: 'login',
            element: <LoginPage />
        },
        {
            path: 'forgot-password-request',
            element: <EmployeeForgotPasswordRequest />
        },
        {
            path: 'forgot-password/:sessionId',
            element: <EmployeeForgotPassword />
        },
        {
            path: 'admin/login',
            element: <UserLoginPage />
        }
    ]
};

export default AuthenticationRoutes;
